import axios from 'axios'
import React from 'react'
import { connect } from 'react-redux'
import swal from 'sweetalert2'
import { Dropdown, DropdownButton, MenuItem } from 'react-bootstrap'
import { logout } from '../../components/Auth/redux/authActions'
import '../assets/navbar.css'
import useOutsideClick from '../../hooks/useOutsideClick'
import { useT } from '@transifex/react'

const UserNav = ({ admin }) => {
  const t = useT();
  const { ref, isOpen, setIsOpen } = useOutsideClick(false)

  const toggleMenu = () => setIsOpen(!isOpen)

  const changePassword = () => {
    swal
      .fire({
        title: t('Change password'),
        html: `<input id="currentPassword" class="swal2-input" type="password" placeholder="${t('Current password')}">
        <input id="newPassword1" class="swal2-input" type="password" placeholder=${t('New password')}>
        <input id="newPassword2" class="swal2-input" type="password" placeholder=${t('Confirm current password')}>`,
        focusConfirm: false,
        confirmButtonColor: '#006E78',
        confirmButtonText: t('Send'),
        showCancelButton: true,
        cancelButtonText: t('Cancel'),
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !swal.isLoading(),
        preConfirm: () => {
          const current = document.getElementById('currentPassword').value
          const newPassword1 = document.getElementById('newPassword1').value
          const newPassword2 = document.getElementById('newPassword2').value

          const { email } = admin.user

          let reason
          if (!current.length) reason = t('Enter your current password')
          if (!newPassword1.length) reason = t('Enter your new password')
          if (newPassword1 !== newPassword2) reason = t('Passwords do not match')

          if (reason) return swal.showValidationMessage(reason)

          return axios.put(`${window.MYQLOCX_API}/newpassword?email=${email}`, { currentPassword: current, newPassword: newPassword1 })
        },
      })
      .then(({ dismiss }) => {
        if (dismiss === 'cancel' || dismiss === 'overlay') return

        swal.fire({
          type: 'success',
          confirmButtonColor: '#006E78',
          text: t('Password changed successfully'),
        })
      })
      .catch(() => {
        swal.fire({
          type: 'error',
          confirmButtonColor: '#006E78',
          text: t('Something went wrong'),
        })
      })
  }

  return (
    <div className="flex" ref={ref}>
      {isOpen ? (
        <Dropdown id="dropdown" onClick={() => setIsOpen(!isOpen)}>
          <DropdownButton defaultOpen pullRight bsSize="xs" title="" id="dropdown-btn">
            <MenuItem onSelect={changePassword}>
              <div style={{ marginLeft: '5px', textAlign: 'left', color: 'black' }}>{t('Change password')}</div>
            </MenuItem>
            <MenuItem onSelect={logout}>
              <div style={{ marginLeft: '5px', textAlign: 'left', color: 'black' }}>{t('Logout')}</div>
            </MenuItem>
          </DropdownButton>
        </Dropdown>
      ) : (
        <div onClick={toggleMenu} style={{ cursor: 'pointer', color: 'white' }}>
          <i className="fa fa-bars" aria-hidden="true" style={{ fontSize: 20 }} />
        </div>
      )}
    </div>
  )
}

const mapProps = (state) => ({
  admin: state.collectionData.admin,
})

export default connect(mapProps, null)(UserNav)
